if (!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.variantId = this.dataset.variantId;
      this.tileType = this.dataset.tileType || 'PDP';
      this.title = this.dataset.title || 'You may also like';
    }

    connectedCallback() {
      if (!this.variantId) {
        this.closest('.product-recommended-products')?.classList.add('hidden');
        return;
      }
      
      poll(() => {
        return window.algoliasearch;
      }, 10000, 150).then(() => {
        this.init();
      }) 
    }
    
    init() {
      if (!this.variantId) return;
      
      const client = window.algoliasearch(algoliaAppId, algoliaAPI);
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale  

      client.getRelatedProducts([
        {
          indexName: 'shopify_products',
          objectID: this.variantId,
        },
        ])
        .then(({ results }) => {
          this.renderResults(results[0]?.hits);
        })
        .catch(err => {
          console.error(err);
          this.closest('.shopify-section.pdp-recommended-products')?.classList.add('hidden');
        });
    }
    
    renderResults(products) {
      const filteredProducts = products.filter((product) => product.inventory_available !== false && !product.tags.find((tag) => tag === 'base-product' || tag === 'hide-product'));
      if (filteredProducts.length < 1 || !filteredProducts) {
        this.closest('.shopify-section').classList.add('hidden');
        return;
      }
      if (this.tileType == 'PDP') {
        this.innerHTML = `
          <ul class="hidden md:grid grid-cols-5 gap-4">
            ${filteredProducts.slice(0, 5).map((product) => `
              <li class="flex items-stretch">
                <intersection-loader 
                  data-url="${this.locale ? `/${this.locale}` : `` }/products/${product.handle}"
                  data-section-id="product-tile"
                ></intersection-loader>
              </li>
            `).join('')}
          </ul>
          <div class="relative z-[1] md:hidden">
            <swiper-container 
              free-mode="true"
              mousewheel-control="true"
              mousewheel-force-to-axis="true"
              scrollbar-enabled="true"
              scrollbar-draggable="true"
              slides-offset-after="16" 
              slides-offset-before="16" 
              space-between="4" 
              slides-per-view="1.75"
              role="region"
              aria-label="Recommended products carousel"
              watch-slides-progress="true"
            >
              ${filteredProducts.slice(0, 6).map((product) => `
                <swiper-slide>
                  <intersection-loader 
                    data-url="${this.locale ? `/${this.locale}` : `` }/products/${product.handle}"
                    data-section-id="product-tile"
                  ></intersection-loader>    
                </swiper-slide>
              `).join('')}
            </swiper-container>
          </div>
        `;
      } else {
        this.innerHTML = `
          <div class="relative z-[1]">
            <button 
              id="data-swiper-prev-reccs"  
              class="justify-center z-10 absolute top-[77px] left-0 bg-secondaryLight w-8 h-6 max-w-8 max-h-6 min-w-8 min-h-6 flex items-center disabled:opacity-0 transition [&_svg]:origin-center [&_svg]:transform [&_svg]:scale-x-[-1]"
            >
              <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M6.75 3.75L12 9L6.75 14.25" stroke="#1C1C1C" stroke-width="2" stroke-linecap="square"/>
              </svg>
            </button>
            <button 
              id="data-swiper-next-reccs"  
              class="justify-center z-10 absolute top-[77px] right-0 bg-secondaryLight w-8 h-6 max-w-8 max-h-8 min-w-6 min-h-6 flex items-center disabled:opacity-0 transition"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M6.75 3.75L12 9L6.75 14.25" stroke="#1C1C1C" stroke-width="2" stroke-linecap="square"/>
              </svg>
            </button>
            <swiper-container 
              space-between="4"
              slides-offset-after="4"
              slides-per-view="3.25"
              navigation="true"
              navigation-next-el="#data-swiper-next-reccs"
              navigation-prev-el="#data-swiper-prev-reccs"
              role="region"
              aria-label="Recommended products carousel"
              watch-slides-progress="true"
            >
              ${filteredProducts.slice(0, 6).map((product) => `
                <swiper-slide>
                  <intersection-loader 
                    data-load-immediately="true"
                    data-url="${Shopify.routes.root}products/${product.handle}"
                    data-section-id="upsell-tile"
                  ></intersection-loader>    
                </swiper-slide>
              `).join('')}
            </swiper-container>
          </div>
        `;
      }
    }
  }

  customElements.define('recommended-products', RecommendedProducts);
}